import { CognitoUser } from "@aws-amplify/auth";
import { Auth } from "aws-amplify";
import UsernameSupplier from "./UsernameSupplier";

export default class AuthUsernameSupplier implements UsernameSupplier {
    public async get(): Promise<string> {
        const user: CognitoUser = await Auth.currentAuthenticatedUser();
        return user.getUsername();
    }
}